import { paymentDetailsKeys } from '@/apis/payments/hooks/useGetPaymentDetail'
import { PaymentDetail } from '@/schemas/payments.schema'
import { PursesArray } from '@/schemas/provider.schema'
import { selectProgramID } from '@/storage/program_settings/programSettingsSlice'
import { useQueryClient } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { z } from 'zod'
import { ReviewMarketplaceOrder } from './ReviewMarketplaceOrder'
import { ReviewSendBillOrder } from './ReviewSendBillOrder'
const RejectPaymentSchema = z.object({
  comment: z.string().min(10, 'Please provide a reason for rejection'),
})
export type RejectPaymentSchema = z.infer<typeof RejectPaymentSchema>

type ReviewPaymentUIProps = {
  payment: PaymentDetail
  pursesData: PursesArray
}

export function ReviewPaymentUI({ payment, pursesData }: ReviewPaymentUIProps) {
  const queryClient = useQueryClient()
  const programId = useSelector(selectProgramID)

  const invalidatePaymentDetails = () => {
    queryClient.invalidateQueries({
      queryKey: paymentDetailsKeys.detail({
        payment_id: payment.payment_id.toString(),
        program_id: programId,
      }),
    })
  }

  if (
    payment.status === 'In review Applicant' &&
    payment.type === 'Marketplace'
  ) {
    return (
      <ReviewMarketplaceOrder
        onSuccess={() => {
          invalidatePaymentDetails()
        }}
        payment={payment}
      />
    )
  }

  if (
    payment.status === 'In review Applicant' &&
    payment.type === 'Send Bill'
  ) {
    return (
      <ReviewSendBillOrder
        onSuccess={() => {
          invalidatePaymentDetails()
        }}
        purses={pursesData}
        payment={payment}
      />
    )
  }

  return null
}
